import React from 'react';

const SiteFooter = () => (
  <footer className="site-footer">
    <span>Rebellionaire.AI</span>
    <nav aria-label="Legal">
      <a href="/terms">Terms and Conditions</a>
      <a href="/disclaimer">Disclaimer</a>
    </nav>
  </footer>
);

export default SiteFooter;
